import { BaseModel } from "sjs-base-model";

export default class AppointmentModel extends BaseModel {
    public readonly customerFullName: string = "";
    public readonly time: string = "";

    constructor(data: Partial<AppointmentModel>) {
        super();

        this.update(data);
    }
}
